import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { Avatar, TextField, Link, Box, Typography, Checkbox, FormControlLabel, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { usePageModel } from "./model";
import Logo from "./logo.png";
import { paths } from "frontend/src/pages/paths/index";
import { GuestUserLayout } from "frontend/src/pages/layouts/guest-user-layout";
import { locales } from "frontend/src/domain/localization/i18n";
import { MultilineHelperText } from "frontend/src/ui/multiline-helper-text";
var Copyright = function () { return (React.createElement(Typography, { variant: "body2", color: "textSecondary", align: "center" },
    "© ",
    React.createElement(Link, { color: "inherit", href: "https://imstream.net/" }, "imstream"),
    " ",
    new Date().getFullYear())); };
var useStyles = makeStyles(function (theme) { return ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    error: {
        color: "red",
    },
}); });
var Page = function () {
    var _a, _b;
    var classes = useStyles();
    var t = useTranslation(locales.namespaces.guest).t;
    var t2 = useTranslation(locales.namespaces.shared).t;
    var _c = usePageModel(), submit = _c.submit, isSubmitting = _c.isSubmitting, errors = _c.errors, username = _c.username, password = _c.password, rememberMe = _c.rememberMe;
    var onSubmit = function (evt) {
        evt.preventDefault();
        submit();
    };
    var onUserNameChange = function (evt) {
        return username.set(evt.target.value);
    };
    var onPasswordChange = function (evt) {
        return password.set(evt.target.value);
    };
    var onRememberMeChange = function (evt) {
        return rememberMe.set(evt.target.checked);
    };
    return (React.createElement(Box, null,
        React.createElement("div", { className: classes.paper },
            React.createElement(Avatar, { className: classes.avatar, src: Logo }),
            React.createElement(Typography, { component: "h1", variant: "h5" }, t("pages.login.header")),
            React.createElement("form", { className: classes.form, noValidate: true, onSubmit: onSubmit },
                React.createElement(TextField, { variant: "outlined", margin: "normal", required: true, fullWidth: true, id: "login", name: "login", label: t("pages.login.username"), autoFocus: true, autoComplete: "username", disabled: isSubmitting, error: !!errors.username, helperText: React.createElement(MultilineHelperText, { texts: (_a = errors.username) !== null && _a !== void 0 ? _a : [] }), value: username.value, onChange: onUserNameChange }),
                React.createElement(TextField, { variant: "outlined", margin: "normal", required: true, fullWidth: true, label: t("pages.login.password"), type: "password", name: "password", id: "password", autoComplete: "current-password", disabled: isSubmitting, error: !!errors.password, helperText: React.createElement(MultilineHelperText, { texts: (_b = errors.password) !== null && _b !== void 0 ? _b : [] }), value: password.value, onChange: onPasswordChange }),
                React.createElement(Box, null,
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { color: "primary", checked: rememberMe.value, onChange: onRememberMeChange }), label: t("pages.login.rememberMe") })),
                errors.unknown && (React.createElement(Typography, { variant: "caption", className: classes.error }, t2("errors.unknown"))),
                React.createElement(ButtonLoader, { isLoading: isSubmitting, type: "submit", fullWidth: true, variant: "contained", color: "primary", className: classes.submit }, t("pages.login.submit"))),
            React.createElement(Box, { display: "flex", justifyContent: "space-between", width: "100%" },
                React.createElement(Link, { component: RouterLink, to: paths.password.forgot(), variant: "body2" }, t("pages.login.forgotPassword")),
                React.createElement(Link, { component: RouterLink, to: paths.register(), variant: "body2" }, t("pages.login.register")))),
        React.createElement(Box, { mt: 4 },
            React.createElement(Typography, { align: "center" },
                React.createElement(Link, { href: "https://player24.imstream.net" }, t("pages.login.previousVersionLogin"))),
            React.createElement(Copyright, null))));
};
export var LoginPage = function () { return (React.createElement(GuestUserLayout, null,
    React.createElement(Page, null))); };
